import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface TeamTimesheetStatusCounts {
  pendingSubmission: number;
  pendingApproval: number;
  approved: number;
  rejected: number;
  total: number;
  month: number;
  year: number;
}

export interface TeamLeaderTimesheetCounts {
  leaderName: string;
  pendingSubmission: number;
  pendingApproval: number;
  approved: number;
  rejected: number;
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class TeamTimesheetMetricsService {
  constructor(private readonly http: HttpClient) {}

  getStatusCountsForEmployee(
    employeeId: string,
    filterType: string | undefined,
    month?: number,
    year?: number,
  ): Observable<TeamTimesheetStatusCounts> {
    let params = new HttpParams().set('employeeId', employeeId);
    if (filterType) params = params.set('filterType', filterType);
    if (month != null) params = params.set('month', String(month));
    if (year != null) params = params.set('year', String(year));
    return this.http.get<TeamTimesheetStatusCounts>(
      `${environment.apiUrl}/metrics/timesheets/status-counts/by-employee`,
      { params },
    );
  }

  getStatusCountsByLeader(
    employeeId: string,
    filterType: string | undefined,
    month?: number,
    year?: number,
  ): Observable<TeamLeaderTimesheetCounts[]> {
    let params = new HttpParams().set('employeeId', employeeId);
    if (filterType) params = params.set('filterType', filterType);
    if (month != null) params = params.set('month', String(month));
    if (year != null) params = params.set('year', String(year));
    return this.http.get<TeamLeaderTimesheetCounts[]>(
      `${environment.apiUrl}/metrics/timesheets/status-counts-by-leader/by-employee`,
      { params },
    );
  }
}
